import { Weight, WeightType } from '@hero/schema';
import { convertWeight } from '@hero/core';
import { useTranslation } from 'react-i18next';

export interface OrderWeightDisplayProps {
  weight: Weight;
  convertWeightTo?: WeightType;
  className?: string;
}

export const OrderWeightDisplay: React.FC<OrderWeightDisplayProps> = ({
  weight,
  convertWeightTo,
  className,
}) => {
  const { t } = useTranslation('m-order');

  // If conversion is specified, convert the weight
  const displayWeight = convertWeightTo
    ? convertWeight(weight, convertWeightTo, {
        decimals: 2,
        removeTrailingZeros: true,
      })
    : weight;

  // Get translated weight type from m-order namespace
  const translatedType = t(`weight_units.${displayWeight.type}`, {
    defaultValue: displayWeight.type,
  });

  return (
    <span className={className}>
      {displayWeight.value} {translatedType}
    </span>
  );
};
